const localeMessages = {
  en_US: {
    "test": "test",
    "dashboard.player": "Player",
    "dashboard.amount": "Amount",
    "dashboard.pay": "Pay",
    "dashboard.log": "Log",
    "button.leave": "Leave the table",
    "button.reload": "Reload",
    "button.allLog": "Show all log",
    "button.joinTable": "Join table",
    "button.watch": "Watch",
    "placeHolder.enterName": "Enter your name",
    "placeHolder.enterEmail": "Enter your email",
    "placeHolder.enterPassword": "Enter your password",
    "placeHolder.confirmPassword": "Confirm password",
    "modalTitle.incomingLog": "Incoming log of",
    "modalTitle.outComingLog": "Outcoming log of",
    "modalTitle.outGoingLog": "OutGoing log",
    "modalTitle.tableLog": "Table log",
    "message.transferred": "transferred",
    "message.received": "received",
    "message.from": "from",
    "message.confirm": "R u sure?",
    "title.login": "Log in",
    "title.logout": "Log out",
    "title.register": "Register",
    "title.welcome": "Welcome",
    "auth.welcomeTitle": "Welcome!",
    "auth.loginSubtitle": "Log in to get started!",
    "auth.registerTitle": "Register",
    "auth.registerSubtitle": "Register to join the community!",
    "auth.noAccount": "Don't have an account?",
    "auth.signUp": "Sign Up",
    "auth.haveAccount": "Already have an account?",
    "auth.signIn": "Sign In",
    "auth.mainTitle.login": "ULTIMATE SCORE TRACKER",
    "auth.mainTitle.register": "ULTIMATE BILLIARDS TRACKER",
    "auth.heroSubtitle": "Track your score and count innings.",
    "auth.updateUsername": "Update Username",
    "auth.newUsername": "New username",
    "auth.usernameUpdated": "Username updated successfully!",
    "title.tableName": "Table name",
    "title.tableHelp":"Table will show to all players",

    "table.chickenHelp":"Create table with chicken to play with friends",
    'title.creator': "Creator",
    "message.nowYouCan": "Now you can",
    "button.createTable": "Create new table",
    "button.create-chick": "Table with chick",
    "button.create": "Create",
    "button.cancel": "Cancel",

    "message.or": "OR",
    "placeHolder.enterTableId": "Enter table ID",
    "message.transferTo": "Transfer to",
    "placeHolder.lossAmount": "Enter loss amount",
    "button.backHome": "Back home",
    "button.scanQrCode": "Scan QR code",
    "auth.username": "Username",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm Password",
    'message.tableNotFound': "Table not found",
    'message.tableFull': "Table is full",
    'message.tableCreated': "Table has been created",
    'message.tableJoined': "You have joined the table",
    'message.tableLeft': "You have left the table",
    'message.tableWatched': "You are watching the table",
    "message.playerHistory": "Joined table history",
    "message.joinedAt": "Joined at",
    "message.notJoined": "You have not joined any table",
    "error.fetUserData":"Cannot get user data",
    "error.fetchTableData": "Cannot get table data",
    "error.fetchPlayerData": "Cannot get player data",
    "error.fetchLogData": "Cannot get log data",
    "error.fetchTableLogData": "Cannot get table log data",
    "error.fetchPlayerHistoryData": "Cannot get player history data",
    "error.fetchTableHistoryData": "Cannot get table history data",
    "error.fetchTableListData": "Cannot get table list",
    "error.createTable": "Cannot create table",
    "error.joinTable": "Cannot join table",
    "error.leaveTable": "Cannot leave table",
    "error.watchTable": "Cannot watch table",
    "error.transferAmount": "Cannot transfer amount",
    "error.scanQrCode": "Cannot scan QR code",
    "error.invalidQrCode": "Invalid QR code",
    "error.invalidTableId": "Invalid table ID",
  },

  vi_VN: {
    test: "Thử nghiệm",
    "dashboard.player": "Người chơi",
    "dashboard.amount": "Tài khoản",
    "dashboard.pay": "Thanh toán",
    "dashboard.log": "Lịch sử",
    "button.leave": "Rời bàn",
    "button.reload": "Tải lại",
    "button.allLog": "Lịch sử",
    "button.joinTable": "Tham gia",
    "button.watch": "Xem",
    "placeHolder.enterName": "Nhập tên",
    "placeHolder.enterEmail": "Nhập email",
    "placeHolder.enterPassword": "Nhập mật khẩu",
    "placeHolder.confirmPassword": "Xác nhận mật khẩu",
    "modalTitle.incomingLog": "Lịch sử nhận",
    "modalTitle.outComingLog": "Lịch sử chuyển",
    "modalTitle.outGoingLog": "Lịch sử chuyển",
    "modalTitle.tableLog": "Lịch sử bàn",
    "message.transferred": "đã chuyển cho",
    "message.received": "đã nhận",
    "message.from": "từ",
    "message.confirm": "Bạn chắc chứ?",
    "title.login": "Đăng nhập",
    "title.logout": "Đăng xuất",
    "title.register": "Đăng ký",
    "title.welcome": "Xin chào",
    "auth.welcomeTitle": "Chào mừng bạn!",
    "auth.loginSubtitle": "Đăng nhập để bắt đầu ngay!",
    "auth.registerTitle": "Đăng ký",
    "auth.registerSubtitle": "Đăng ký để tham gia cộng đồng!",
    "auth.noAccount": "Chưa có tài khoản?",
    "auth.signUp": "Đăng Ký",
    "auth.haveAccount": "Đã có tài khoản?",
    "auth.signIn": "Đăng Nhập",
    "auth.mainTitle.login": "ULTIMATE SCORE TRACKER",
    "auth.mainTitle.register": "ULTIMATE BILLIARDS TRACKER",
    "auth.heroSubtitle": "Theo dõi điểm số và đếm số hiệp.",
    "auth.updateUsername": "Đổi tên",
    "auth.newUsername": "Tên mới",
    "auth.usernameUpdated": "Đổi tên thành công!",
    "title.tableName": "Tên bàn",
    "title.tableHelp": "Bàn sẽ hiển thị cho tất cả người chơi",
    "table.chickenHelp": "Tạo bàn có gà để chơi với bạn bè",
    'title.creator': "Người tạo",
    "message.nowYouCan": "Bây giờ bạn có thể",
    "button.createTable": "Tạo bàn mới",
    "button.create": "Tạo bàn",
    "button.create-chick": "Bàn có gà",
    "button.cancel": "Hủy",
    "message.or": "Hoặc",
    "placeHolder.enterTableId": "Nhập ID bàn",
    "message.transferTo": "Chuyển cho",
    "placeHolder.lossAmount": "Nhập số tiền chuẩn bị mất",
    "button.backHome": "Về trang chủ",
    "button.scanQrCode": "Quét mã QR",
    "auth.username": "Tên đăng nhập",
    "auth.email": "Email",
    "auth.password": "Mật khẩu",
    "auth.confirmPassword": "Xác nhận mật khẩu",
    'message.tableNotFound': "Bàn không tồn tại",
    'message.tableFull': "Bàn đã đầy",
    'message.tableCreated': "Bàn đã được tạo",
    'message.tableJoined': "Bạn đã tham gia bàn",
    'message.tableLeft': "Bạn đã rời bàn",
    'message.tableWatched': "Bạn đang xem bàn",
    "message.playerHistory": "Lịch sử bàn đã tham gia",
    "message.joinedAt": "Tham gia lúc",
    "message.notJoined": "Bạn chưa tham gia bàn nào",
    "error.fetUserData":"Không thể lấy dữ liệu người dùng",
    "error.fetchTableData": "Không thể lấy dữ liệu bàn",
    "error.fetchPlayerData": "Không thể lấy dữ liệu người chơi",
    "error.fetchLogData": "Không thể lấy dữ liệu lịch sử",
    "error.fetchTableLogData": "Không thể lấy dữ liệu lịch sử bàn",
    "error.fetchPlayerHistoryData": "Không thể lấy dữ liệu lịch sử người chơi",
    "error.fetchTableHistoryData": "Không thể lấy dữ liệu lịch sử bàn",
    "error.fetchTableListData": "Không thể lấy danh sách bàn",
    "error.createTable": "Không thể tạo bàn",
    "error.joinTable": "Không thể tham gia bàn",
    "error.leaveTable": "Không thể rời bàn",
    "error.watchTable": "Không thể xem bàn",
    "error.transferAmount": "Không thể chuyển số tiền",
    "error.scanQrCode": "Không thể quét mã QR",
    "error.invalidQrCode": "Mã QR không hợp lệ",
    "error.invalidTableId": "ID bàn không hợp lệ",
  },
};
export default localeMessages;
